import { cloneDeep } from 'lodash'
import {
  httpGet,
  httpPost,
  httpPatchMerge,
  httpPatch,
  httpDelete,
} from './http'
import type { TEntityId } from '~/types/models'
import type { IOrderMSService } from '~/types/order/models'

const apiEntityPath = '/api/ordermsservices'

export async function getCompanyFromOrderMSService(id: TEntityId) {
  const callingMn = getCompanyFromOrderMSService.name
  const apiPath = `${apiEntityPath}/${id}/company`
  return httpGet<IOrderMSService>({ callingMn, apiPath })
}

export async function createOrderMSService(entity: IOrderMSService) {
  const callingMn = createOrderMSService.name
  const blah = cloneDeep(entity)
  const apiPath = apiEntityPath
  return httpPost<IOrderMSService>({
    callingMn,
    apiPath,
    entity,
    asyncOptions: { doAsync: true },
  })
}

export async function updateOrderMSService(
  entityData: Partial<IOrderMSService> | Partial<IOrderMSService>[],
  id: TEntityId
) {
  const callingMn = updateOrderMSService.name
  if (Array.isArray(entityData)) {
    const apiPath = `${apiEntityPath}`
    return httpPatch<Partial<IOrderMSService>[]>({
      callingMn,
      apiPath,
      entityData,
      asyncOptions: { doAsync: true },
    })
  }
  const apiPath = `${apiEntityPath}/${id}`
  return httpPatchMerge<Partial<IOrderMSService>>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOrderMSService(
  entityData: IOrderMSService | IOrderMSService[]
) {
  const callingMn = deleteOrderMSService.name
  const apiPath = apiEntityPath
  return httpDelete<IOrderMSService | IOrderMSService[]>({
    callingMn,
    apiPath,
    entityData,
  })
}
